export default "__VITE_ASSET__RnugzOBk__"